import { render, staticRenderFns } from "./SubmitTaxData.vue?vue&type=template&id=620b5114&scoped=true&"
import script from "./SubmitTaxData.vue?vue&type=script&lang=js&"
export * from "./SubmitTaxData.vue?vue&type=script&lang=js&"
import style0 from "./SubmitTaxData.vue?vue&type=style&index=0&id=620b5114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b5114",
  null
  
)

export default component.exports